import React from 'react';
import styles from './title.module.css';

function Title({title}) {
  const {top, topText} = styles;
  return (
    <div className={top}>
      <span className={topText}>{title}</span>
    </div>
  );
}

export default Title;
